const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <p>© {currentYear} Tiryaq. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
